import { useField } from 'react-final-form';
import { eirlFormValueToBoolean } from '@eogile/agrements-common/src/demand/demandFormUtils';

export const useEirlFormValue = () => {
  const eirlField = useField('acquirer.eirl', { subscription: { value: true } });
  return eirlFormValueToBoolean(eirlField.input.value);
};
